var $f06e9c465fb83243$exports = {};
$f06e9c465fb83243$exports = {
    "decrease": (args)=>`Suma\u{17E}inti ${args.fieldLabel}`,
    "increase": (args)=>`Padidinti ${args.fieldLabel}`,
    "numberField": `Numerio laukas`
};


export {$f06e9c465fb83243$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
